var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
var Mobile = function (_a) {
    var onClick = _a.onClick, className = _a.className;
    return (_jsx("svg", __assign({ width: '12', height: '16', viewBox: '0 0 12 16', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', className: className, onClick: onClick }, { children: _jsx("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M2.75 1.5C2.05964 1.5 1.5 2.05964 1.5 2.75V13.25C1.5 13.9404 2.05964 14.5 2.75 14.5H9.25024C9.94059 14.5 10.5002 13.9404 10.5002 13.25V2.75C10.5002 2.05964 9.94059 1.5 9.25023 1.5H2.75ZM0 2.75C0 1.23122 1.23121 0 2.75 0H9.25023C10.769 0 12.0002 1.23122 12.0002 2.75V13.25C12.0002 14.7688 10.769 16 9.25024 16H2.75C1.23122 16 0 14.7688 0 13.25V2.75ZM5 12.75C5 12.3358 5.33579 12 5.75 12H6.25C6.66421 12 7 12.3358 7 12.75C7 13.1642 6.66421 13.5 6.25 13.5H5.75C5.33579 13.5 5 13.1642 5 12.75Z', fill: '#212A3D' }) })));
};
export { Mobile };
//# sourceMappingURL=Mobile.js.map